import { createFileRoute } from '@tanstack/react-router'
import { UnauthorizedPage } from '../../src/pages/Core/Unauthorized'
import { emptySearchSchema } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/unauthorized')({
  validateSearch: (search) => emptySearchSchema.parse(search),
  loaderDeps: () => ({}),
  staticData: {
    englishAllowed: true,
  },
  component: UnauthorizedPage,
})
